
// Top-level config (shared)
window.INVENTORY_API_CONFIG = window.INVENTORY_API_CONFIG || {
  "la-apparel-dev.myshopify.com": { apiBase: "https://aims-gtn.com/main/laa/shopify/inventory/", env: "dev" },
  "losangelesapparel.net": { apiBase: "https://aims-gtn.com/main/laa/shopify/inventory/", env: "prod" },
};

window.getAimsConfig = window.getAimsConfig || function getAimsConfig() {
  return window.INVENTORY_API_CONFIG[window.location.hostname] || window.INVENTORY_API_CONFIG["losangelesapparel.net"];
};

class PickupInventoryTable extends HTMLElement {
  constructor() {
    super();
    this._initialized = false;
    this.onAddToCart  = this.onAddToCart.bind(this);
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    this.variantId = this.dataset.variantId;
    this.listEl    = this.querySelector('[data-store-availability-drawer-content]');
    if (!this.variantId || !this.listEl) return;

    this.loadStyles();
    this.attachAddToCartHandlers();
    this.fetchInventoryCount();
  }

  disconnectedCallback() {
    this.listEl.removeEventListener('click', this.onAddToCart);
  }

  loadStyles() {
    if (window.__pickupInventoryStylesInjected) return;
    window.__pickupInventoryStylesInjected = true;

    const style = document.createElement('style');
    style.textContent = `

    /* container */
    .location-links {
      font-size: 1.6rem;  /* adjust to match comp */
      line-height: 1.2;
    }
    
    /* rich text usually outputs a <p> */
    .location-links p {
      margin: 0;
      display: inline; /* keep it from creating extra spacing */
    }
    
    /* link styling */
    .location-links a {
      color: currentColor;
      text-decoration: underline;
      text-underline-offset: 2px;  /* gives that nice comp look */
    }
    
    /* insert the pipe between the two links */
    .location-links a + a::before {
      content: " | ";
      color: currentColor;
      text-decoration: none; /* pipe NOT underlined */
    }

    .pickup-availability-preview-wrap {
      display: block;
    }
    
    .pickup-availability-top {
      margin: 0 0 10px 0;
    }

    .pickup-label, .delivery-label {
      font-family: 'Univers LT W01_65 Bold1475968';
      font-weight: 700;
    }

    .pickup-availability-line {
      margin: 0;
      line-height: 1.35;
    }    
    /* Keep the whole line tight */
    .pickup-availability-secondary {
      display: flex;
    align-items: center;
    gap: 2px;
    line-height: 1;
    margin: 4px 0 0;
    }
    
    /* Make the svg NOT affect line box height */
    .uber-word {
      display: inline-flex;
    align-items: center;
    line-height: 0;
    position: relative;
    }
    
    /* Force logo height */
    .uber-logo {
      height: 42px;
      width: auto;
      display: block;
      fill: #000;
      position: absolute;
    }
    /* --- badge styling --- */
    .inventory-count {
      display: inline-block;
      margin-left: 0;
      padding: 2px 8px;
      border-radius: 8px;
      font-weight: 700;
      line-height: 1.2;
    
      /* default = "good / available" look from screenshot */
      color: #1f8a3b;
      border: 1px solid #1f8a3b;
      background: transparent;
    }
    
    /* keep your states, but match the badge look */
    .inventory-count.avail {
      color: #1f8a3b;
      border-color: #1f8a3b;
    }
    
    .inventory-count.limited {
      color: #e79500;
      border-color: #e79500;
    }
    
    .inventory-count.no-qty {
      color: #ff0000;
      border-color: #ff0000;
    }
    `;
    document.head.appendChild(style);
  }

  getApiConfig() {
    return window.getAimsConfig();
  }

  async fetchInventoryCount() {
    const { apiBase, env } = window.getAimsConfig();
    const url = `${apiBase}${this.variantId}?env=${env}`;

    try {
      const res = await fetch(url);
      if (!res.ok) throw new Error(res.statusText);
      const data = await res.json();

      (data.inventory || []).forEach(loc => {
        const locId = loc.location_id.split('/').pop();
        const li    = this.listEl.querySelector(`li[data-location-id="${locId}"]`);
        if (!li || !loc.pickup_available) {
          li?.classList.add('hidden');
          return;
        }

        const span = li.querySelector('.inventory-count');
        if (!span) return;

        const qty = loc.quantities?.available ?? 0;
        let text = `${qty} Available`;
        let cls  = '';
        if (qty > 10)        { text = '10+ Available'; cls = 'avail'; }
        else if (qty === 0)  { text = '0 Available';   cls = 'no-qty'; }
        else if (qty < 5)    { text = 'Almost gone!';   cls = 'limited'; }

        span.textContent = text;
        if (cls) span.classList.add(cls);
      });
    } catch (err) {
      console.error('Error loading inventory:', err);
    }
  }

  attachAddToCartHandlers() {
    this.listEl.addEventListener('click', this.onAddToCart);
  }

  async onAddToCart(event) {
    const btn = event.target.closest('.pickup-add-to-cart-btn');
    if (!btn) return;

    btn.classList.add('loading');
    const variantId = btn.dataset.variantId;
    const location  = btn.dataset.locationName;
    const { apiBase, env } = this.getApiConfig();
    const bubble    = document.querySelector('.cart-count-bubble.cart_count');
    const cartIcon  = document.querySelector('.js-ajax-cart-drawer-trigger');

    let canShip = true;
    try {
      const res = await fetch(`${apiBase}${variantId}?env=${env}`);
      const { inventory = [] } = await res.json();
      const chosen = inventory.find(l => l.location_name === location);
      canShip = Boolean(chosen?.ships_inventory && chosen.quantities.available > 0);
    } catch (e) {
      console.error('Shipping-availability check failed', e);
    }

    try {
      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          properties: {
            pickup_location: location
          }
        })
      });
      if (!addRes.ok) throw new Error('Add to cart failed');

      const cartRes = await fetch('/cart.js');
      const cart    = await cartRes.json();
      bubble && (bubble.textContent = cart.item_count);

      window.Shopify?.AjaxCart?.api.updateCart();
      cartIcon?.click();
    } catch (e) {
      console.error(e);
      alert('Sorry, could not add to cart.');
    } finally {
      btn.classList.remove('loading');
    }
  }
}

if (!customElements.get('pickup-inventory-table')) {
  customElements.define('pickup-inventory-table', PickupInventoryTable);
}
